<template>
  <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5247 14.8906C12.9222 14.8906 12.4338 15.379 12.4338 15.9814V17.0723H11.343C10.7406 17.0723
    10.2522 17.5606 10.2522 18.1631C10.2522 18.7655 10.7406 19.2539 11.343 19.2539H12.4338V20.3447C12.4338 20.9472
    12.9222 21.4355 13.5247 21.4355C14.1271 21.4355 14.6155 20.9472 14.6155 20.3447V19.2539H15.7063C16.3087 19.2539
    16.7971 18.7655 16.7971 18.1631C16.7971 17.5606 16.3087 17.0723 15.7063
    17.0723H14.6155V15.9814C14.6155 15.379 14.1271 14.8906 13.5247 14.8906Z" :fill="colorDisabled"/>
    <path d="M8.24636 20.0127C8.7108 20.0127 9.08729 19.6362 9.08729 19.1717C9.08729
    18.7073 8.7108 18.3308 8.24636 18.3308V20.0127ZM15.6765 13.905C15.6765 14.3694 16.053 14.7459
    16.5174 14.7459C16.9819 14.7459 17.3584 14.3694 17.3584 13.905H15.6765ZM8.24636
    18.3308H3.16478V20.0127H8.24636V18.3308ZM2.32384
    17.4899V3.14085H0.641976V17.4899H2.32384ZM15.6765 3.14085V13.905H17.3584V3.14085H15.6765ZM3.16478
    2.29992H11.0061V0.618051H3.16478V2.29992ZM11.0061
    2.29992H14.8356V0.618051H11.0061V2.29992ZM17.3584 3.14085C17.3584 1.74755 16.2289 0.618051 14.8356
    0.618051V2.29992C15.3 2.29992 15.6765 2.67642 15.6765
    3.14085H17.3584ZM2.32384 3.14085C2.32384 2.67642 2.70034 2.29992 3.16478
    2.29992V0.618051C1.77147 0.618051 0.641976 1.74754 0.641976
    3.14085H2.32384ZM3.16478 18.3308C2.70034 18.3308 2.32384 17.9543 2.32384 17.4899H0.641976C0.641976
    18.8832 1.77148 20.0127 3.16478 20.0127V18.3308Z" :fill="colorDisabled"/>
  </svg>
</template>

<script>
export default {
  name: 'BBPIconNewFolder',
  props: ['colorDisabled']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPIcons/BBPIconNewFolder.vue